var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$auth.isAuthenticated && _vm.$auth.user.email)?_c('div',[_c('AppMain')],1):_c('div',{staticClass:"bg-primary show",attrs:{"id":"page-loader"}})
}
var staticRenderFns = []

export { render, staticRenderFns }